import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function DataExfiltrationInterface() {
  const navigate = useNavigate();
  const [sourceIp, setSourceIp] = useState('192.168.1.10');
  const [filePath, setFilePath] = useState('/var/www/html/config.php');
  const [destination, setDestination] = useState('Encrypted Tunnel (GLOCYBS Secure Cloud)');
  const [exfilLog, setExfilLog] = useState([]);
  const [isExfiltrating, setIsExfiltrating] = useState(false);
  const [exfilProgress, setExfilProgress] = useState(0);

  const exfilSimulations = [
    `[INIT] Preparing data exfiltration from ${sourceIp}...`,
    `[STEP 1/4] Establishing secure encrypted tunnel to destination...`,
    `[STEP 2/4] Authenticating with compromised target system...`,
    `[STEP 3/4] Locating target file: ${filePath}...`,
    `[STEP 4/4] Initiating data transfer...`,
    `[TRANSFER] Transferring chunk 1/5... (20%)`,
    `[TRANSFER] Transferring chunk 2/5... (40%)`,
    `[TRANSFER] Transferring chunk 3/5... (60%)`,
    `[TRANSFER] Transferring chunk 4/5... (80%)`,
    `[TRANSFER] Transferring chunk 5/5... (100%)`,
    `[SUCCESS] File '${filePath}' (${(Math.random() * 5 + 1).toFixed(1)}MB) transferred successfully to ${destination}.`,
    `[VERIFY] Data integrity check: OK.`,
    `[CLEANUP] Removing traces on target system...`,
    `[COMPLETE] Exfiltration operation finished.`,
    `glocybs@console:~$ `
  ];

  const startExfiltration = () => {
    setIsExfiltrating(true);
    setExfilLog([]);
    setExfilProgress(0);
    let currentLine = 0;

    const exfilInterval = setInterval(() => {
      if (currentLine < exfilSimulations.length) {
        setExfilLog(prev => [...prev, exfilSimulations[currentLine]]);
        setExfilProgress(Math.floor((currentLine / exfilSimulations.length) * 100));
        currentLine++;
      } else {
        clearInterval(exfilInterval);
        setIsExfiltrating(false);
        setExfilProgress(100);
      }
    }, 400); // Simulate transfer speed

    return () => clearInterval(exfilInterval);
  };

  const commonStyles = { // Re-using common styles
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a0a1a 0%, #1a0a2a 50%, #0a0a1a 100%)',
      fontFamily: "'Inter', sans-serif",
      color: '#00e6e6',
      overflowX: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
      boxSizing: 'border-box',
    },
    '@keyframes subtleGridMove': {
      '0%': { backgroundPosition: '0 0' },
      '100%': { backgroundPosition: '100% 100%' },
    },
    '::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: `
        linear-gradient(to right, rgba(0, 230, 230, 0.05) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(0, 230, 230, 0.05) 1px, transparent 1px)
      `,
      backgroundSize: '20px 20px',
      animation: 'subtleGridMove 60s linear infinite',
      opacity: 0.2,
      zIndex: 0,
    },
    headerBar: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: 'rgba(10, 10, 26, 0.95)',
      padding: '15px 30px',
      borderRadius: '8px',
      marginBottom: '15px',
      border: '1px solid rgba(0, 230, 230, 0.3)',
      boxShadow: '0 0 20px rgba(0, 230, 230, 0.2)',
      zIndex: 5,
      flexWrap: 'wrap',
      gap: '10px',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '10px 15px',
      },
    },
    headerSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      '@media (max-width: 768px)': {
        width: '100%',
        justifyContent: 'space-between',
        marginBottom: '5px',
      },
    },
    headerLabel: {
      fontSize: '11px',
      color: '#888',
      textTransform: 'uppercase',
      letterSpacing: '0.8px',
      '@media (max-width: 480px)': {
        fontSize: '10px',
      },
    },
    headerValue: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#00e6e6',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    progressBar: {
      width: '60px',
      height: '4px',
      background: 'rgba(0, 230, 230, 0.2)',
      borderRadius: '2px',
      overflow: 'hidden',
      display: 'block',
      border: '1px solid rgba(0, 230, 230, 0.4)',
    },
    progressFill: {
      height: '100%',
      background: 'linear-gradient(90deg, #ffa502, #d18a00)', // Exfiltration specific color
      transition: 'width 0.1s ease',
      boxShadow: '0 0 6px #ffa502',
    },
    mainContent: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr', // Two columns for this page
      gap: '20px',
      flex: 1,
      zIndex: 2,
      '@media (max-width: 1024px)': { // Adjust breakpoint for this page
        gridTemplateColumns: '1fr', // Single column for smaller screens
      },
    },
    panel: {
      background: 'rgba(10, 10, 26, 0.8)',
      border: '1px solid rgba(0, 230, 230, 0.2)',
      borderRadius: '8px',
      padding: '20px',
      boxShadow: '0 0 15px rgba(0, 230, 230, 0.1)',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: '200px',
      '@media (max-width: 480px)': {
        padding: '15px',
      },
    },
    panelHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '15px',
      fontWeight: 'bold',
      color: '#ffa502', // Exfiltration specific header color
      marginBottom: '15px',
      letterSpacing: '0.8px',
      borderBottom: '1px dashed rgba(255, 165, 2, 0.2)',
      paddingBottom: '10px',
      '@media (max-width: 480px)': {
        fontSize: '13px',
        marginBottom: '10px',
      },
    },
    panelIcon: {
      fontSize: '20px',
      lineHeight: 1,
      '@media (max-width: 480px)': {
        fontSize: '16px',
      },
    },
    formGroup: {
      marginBottom: '15px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    label: {
      fontSize: '12px',
      color: '#888',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    input: {
      width: 'calc(100% - 20px)',
      padding: '10px',
      background: 'rgba(0, 0, 0, 0.4)',
      border: '1px solid rgba(255, 165, 2, 0.4)',
      borderRadius: '5px',
      color: '#ffa502',
      fontSize: '14px',
      fontFamily: "'Courier New', monospace",
      '&:focus': {
        outline: 'none',
        borderColor: '#ffa502',
        boxShadow: '0 0 8px rgba(255, 165, 2, 0.5)',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    select: { // Used for destination, although it's a fixed value here
      width: '100%',
      padding: '10px',
      background: 'rgba(0, 0, 0, 0.4)',
      border: '1px solid rgba(255, 165, 2, 0.4)',
      borderRadius: '5px',
      color: '#ffa502',
      fontSize: '14px',
      fontFamily: "'Courier New', monospace",
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='%23FFA502' d='M9.293 12.95l-3.536-3.536.707-.707L10 11.536l3.536-3.536.707.707z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 10px center',
      backgroundSize: '12px',
      '&:focus': {
        outline: 'none',
        borderColor: '#ffa502',
        boxShadow: '0 0 8px rgba(255, 165, 2, 0.5)',
      },
      '@media (max-width: 480px)': {
        fontSize: '12px',
      },
    },
    actionButton: {
      background: 'linear-gradient(45deg, #ffa502, #d18a00)', // Exfiltration specific button color
      color: '#0a0a1a',
      border: 'none',
      borderRadius: '8px',
      padding: '12px 25px',
      fontSize: '15px',
      fontWeight: 'bold',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      transition: 'all 0.3s ease',
      boxShadow: '0 0 10px rgba(255, 165, 2, 0.4)',
      justifyContent: 'center',
      width: 'fit-content',
      margin: '20px auto 0',
      '&:hover': {
        transform: 'translateY(-3px)',
        boxShadow: '0 5px 20px rgba(255, 165, 2, 0.6)',
      },
      '&:disabled': {
        background: 'linear-gradient(45deg, #555, #333)',
        cursor: 'not-allowed',
        boxShadow: 'none',
        transform: 'none',
        color: '#888',
      },
      '@media (max-width: 480px)': {
        width: '100%',
        padding: '10px 15px',
        fontSize: '13px',
      },
    },
    terminalOutput: {
      background: 'rgba(0, 0, 0, 0.6)',
      border: '1px solid rgba(255, 165, 2, 0.3)',
      borderRadius: '5px',
      padding: '15px',
      flex: 1,
      overflowY: 'scroll',
      scrollbarWidth: 'thin',
      scrollbarColor: '#ffa502 #0a0a1a',
      lineHeight: '1.5',
      fontSize: '11px',
      whiteSpace: 'pre-wrap',
      fontFamily: "'Courier New', monospace",
      '&::-webkit-scrollbar': { width: '6px' },
      '&::-webkit-scrollbar-track': { background: '#0a0a1a', borderRadius: '3px' },
      '&::-webkit-scrollbar-thumb': { background: '#ffa502', borderRadius: '3px' },
      '@media (max-width: 480px)': {
        fontSize: '9px',
        padding: '10px',
      },
    },
    terminalLine: {
      marginBottom: '2px',
      color: '#ffa502',
      textShadow: '0 0 2px rgba(255, 165, 2, 0.5)',
    },
    // Back button
    backButton: {
      background: 'linear-gradient(45deg, #444, #222)',
      color: '#ffa502',
      border: '1px solid #ffa502',
      borderRadius: '5px',
      padding: '8px 15px',
      fontSize: '12px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      position: 'absolute',
      top: '15px',
      left: '15px',
      zIndex: 10,
      '&:hover': {
        background: 'linear-gradient(45deg, #ffa502, #d18a00)',
        color: '#0a0a1a',
        boxShadow: '0 0 10px rgba(255, 165, 2, 0.6)',
      },
      '@media (max-width: 480px)': {
        padding: '6px 10px',
        fontSize: '10px',
        top: '10px',
        left: '10px',
      },
    },
  };

  return (
    <div style={commonStyles.container}>
      <button style={commonStyles.backButton} onClick={() => navigate('/')}>
        ← Back to Main
      </button>

      <div style={commonStyles.headerBar}>
        <div style={commonStyles.headerSection}>
          <span style={commonStyles.headerLabel}>MODULE:</span>
          <span style={commonStyles.headerValue}>DATA EXFILTRATION</span>
        </div>
        <div style={commonStyles.headerSection}>
          <span style={commonStyles.headerLabel}>STATUS:</span>
          <span style={commonStyles.headerValue}>
            {isExfiltrating ? 'TRANSFERRING...' : 'READY'}
          </span>
        </div>
        <div style={commonStyles.headerSection}>
          <span style={commonStyles.headerLabel}>PROGRESS:</span>
          <span style={commonStyles.headerValue}>
            <span style={commonStyles.progressBar}>
              <div style={{...commonStyles.progressFill, width: `${exfilProgress}%`}}></div>
            </span>
            {exfilProgress}%
          </span>
        </div>
      </div>

      <div style={commonStyles.mainContent}>
        {/* Left Panel: Exfiltration Configuration */}
        <div style={commonStyles.panel}>
          <div style={commonStyles.panelHeader}>
            <span style={commonStyles.panelIcon}>📁</span> EXFILTRATION CONFIGURATION
          </div>
          <div style={commonStyles.formGroup}>
            <label style={commonStyles.label} htmlFor="sourceIp">Source System IP:</label>
            <input
              style={commonStyles.input}
              type="text"
              id="sourceIp"
              value={sourceIp}
              onChange={(e) => setSourceIp(e.target.value)}
              placeholder="e.g., 192.168.1.10"
              disabled={isExfiltrating}
            />
          </div>
          <div style={commonStyles.formGroup}>
            <label style={commonStyles.label} htmlFor="filePath">File/Data Path:</label>
            <input
              style={commonStyles.input}
              type="text"
              id="filePath"
              value={filePath}
              onChange={(e) => setFilePath(e.target.value)}
              placeholder="e.g., /etc/passwd or /var/log/messages"
              disabled={isExfiltrating}
            />
          </div>
          <div style={commonStyles.formGroup}>
            <label style={commonStyles.label}>Destination:</label>
            <div style={{...commonStyles.input, cursor: 'default', color: '#ffa502'}}>
              {destination}
            </div> {/* Display as a non-editable input */}
          </div>
          <button
            style={commonStyles.actionButton}
            onClick={startExfiltration}
            disabled={isExfiltrating}
          >
            <span style={commonStyles.panelIcon}>📤</span> {isExfiltrating ? 'TRANSFERRING...' : 'START EXFILTRATION'}
          </button>
        </div>

        {/* Right Panel: Transfer Log */}
        <div style={commonStyles.panel}>
          <div style={commonStyles.panelHeader}>
            <span style={commonStyles.panelIcon}>📦</span> TRANSFER LOG
          </div>
          <div style={commonStyles.terminalOutput}>
            {exfilLog.map((line, index) => (
              <div key={index} style={commonStyles.terminalLine}>
                {line}
              </div>
            ))}
            {isExfiltrating && <div style={commonStyles.terminalLine}>_</div>} {/* Blinking cursor */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataExfiltrationInterface;